import axios, { AxiosInstance } from "axios";
import { IApiServiceResponse } from "../types/api";
import settings from "../settings";
import { routeUrls } from "../config/routeUrls";
import i18n from "../i18n";

class basicRequest {
    instance: AxiosInstance;
    hasDefaultParams: boolean;
    timeoutOverride: number;

    constructor(hasDefaultParams?: boolean, timeoutOverride?: number) {

        this.hasDefaultParams = hasDefaultParams || true;
        this.timeoutOverride = timeoutOverride || 30000;

        // inizializzo axios in una variabile di classe
        this.instance = axios.create({
            baseURL: settings.apiBaseUrl, // base url del server
            timeout: this.timeoutOverride, // MS,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': "Bearer " + window.sessionStorage.getItem('accessToken')
            }    
        });

        // Response interceptor for API calls
        this.instance.interceptors.response.use(
            (response) => {
                return response;
            },
            async (error) => {
                if (!error.response) {
                    return new Promise((resolve, reject) => {
                        reject(error);
                    });
                }

                // L'interceptor globale gestirà gli errori 401
                // Qui gestiamo solo errori di rete o altri errori specifici
                return Promise.reject(error);
            }
        );
    }

    // funzione per ottenere accountId & contactId & lang
    getAccountParams = () => {
        return {
            lang: i18n.resolvedLanguage,
            accountId: window.sessionStorage.getItem("accountId"),
            contactId: window.sessionStorage.getItem("contactId")
        }
    };

    // Costruzione dei parametri querystring
    createParams = (params: any) => {
        let allParams = {};
        if (this.hasDefaultParams) {
            allParams = {
                ...allParams,
                ...this.getAccountParams()
            };
        }

        if (params !== null) {
            allParams = {
                ...allParams,
                ...params
            };
        }

        return allParams;
    }

    // Chiamata API CRUD
    // GET (READ)
    get = async (path: string, params: (any) = null): Promise<IApiServiceResponse> => {
        return await this.instance.get(path, {
            params: this.createParams(params)
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            console.log('error', error);
            return {
                success: false,
                error: error
            }
        });
    };



    // POST (Create)
    post = async (path: string, obj = {}, params: any = null): Promise<IApiServiceResponse> => {
        return await this.instance.post(path, obj, {
           params: this.createParams(params)
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            console.log('error', error);
            return {
                success: false,
                error: error
            }
        });
    };

    

    // DELETE 
    delete = async (path: string, obj = {}, params: any = null): Promise<IApiServiceResponse> => {
        return await this.instance.delete(path, {
            data: obj,
            params: this.createParams(params)
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            console.log('error', error);
            return {
                success: false,
                error: error
            }
        });
    };
}

export default basicRequest;